export const _status = [
    {id: "completed", value: "Completed"},
    {id: "open", value: "Open"},
    {id: "closed", value: "Closed"},
    {id: "inReview", value: "In Review"},
    {id: "revertToApplicant", value: "Revert To Applicant"},
    {id: "discrepancy", value: "Discrepancy"},
    {id: "un-verified", value: "Un Verified"},
];

export const verificationList = [
    {id: "oral", value: "Oral Verification"},
    {id: "written", value: "Written Verification"},
    {id: "general", value: "General Comments"}
];
export const screeningDuration = [
    {id: "4", value: "5 Years"},
    {id: "9", value: "10 Years"}
];
export const oralSteps = [
    {
        id: 'on-call-request',
        type: 'on-call',
        value: 'Make call to employer'
    },
    {
        id: 'on-call-response',
        type: 'on-call',
        value: 'Got response from employer'
    },
    {
        id: 'completed',
        type: 'on-call',
        value: 'Verification Completed'
    }
];
export const writtenSteps = [
    {
        id: 'onEmailRequest',
        type: 'written',
        value: 'Email to employer'
    },
    {
        id: 'onEmailResponse',
        type: 'written',
        value: 'Employer response'
    },
    {
        id: 'completed',
        type: 'written',
        value: 'Verification Completed'
    }
];